import { isString } from 'lodash-es';
import type { PassportApplication } from '@unanet/unafy';
import { type AppLauncherComponentProps, experienceCenterApp } from './models';

export const adjustApps = (
  envApps: PassportApplication[],
  userApps: string[]
) => {
  const myApps = envApps
    .filter((app) => userApps?.includes(app.GroupName) || app.Product === 'ec')
    .map((app) => {
      // display context instead of generic defaulted description
      if (app.Product !== 'ec') {
        app.Description = app.CustomerIdentifier;
      } else {
        app.Description = experienceCenterApp.Description;
      }
      return app;
    });

  if (!myApps.some((a) => a.Product === 'ec')) {
    myApps.push(experienceCenterApp);
  }

  return myApps;
};

export const envAppsMatchUserApps = (
  envApps: PassportApplication[],
  userApps: string[]
) => {
  const envAppsByGroupName = envApps.map((ea) => ea.GroupName);
  return envAppsByGroupName.sort().join('|') === userApps.sort().join('|');
};

export const parseProps = ({
  apps: appsString,
  issuer,
  sandbox: sandboxProp,
  userKey: userKeyProp,
}: AppLauncherComponentProps) => {
  const apps: { apps: [] } = appsString ? JSON.parse(appsString) : { apps: [] };
  const parsedUserKey = Number(userKeyProp);
  const sandbox = isString(sandboxProp)
    ? sandboxProp?.toLowerCase() === 'true'
    : sandboxProp;
  const userKey = !isNaN(parsedUserKey) ? parsedUserKey : undefined;

  return {
    apps,
    issuer,
    sandbox,
    userKey,
  };
};
